import makeStyles from '@mui/styles/makeStyles';
import colors from 'global/styles/colors';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
  },
  deleteButton: {
    backgroundColor: theme.colors.danger,
    marginLeft: theme.spacing(1),
  },
  formStyle: {
    margin: 'auto',
    maxWidth: '600px',

    '& .titleContainer': {
      maxWidth: 'none',
    },
    '& .initialFiles > div': {
      width: '100%',
    },
  },
  fileWrap: {
    position: 'relative',
  },
  fileMargin: {
    margin: theme.spacing(1),
  },
  videoDelete: {
    position: 'absolute',
    right: 10,
    top: 10,
    zIndex: 100,
    backgroundColor: colors.grey,
    color: colors.white,

    '&:hover': {
      backgroundColor: colors.disabledGray,
    },
  },
}));

export default useStyles;
